import React from 'react';
import {
  FileBox,
  FileBoxContainer,
  FileBoxMain,
  FileIconDiv,
  FileInfo,
  FileSize,
  FileTitle,
  FileType,
  ImageDiv
} from './styles';
import { extensionName } from '../../helpers/common';
import { FILE_EXTENSIONS, FILE_TYPES, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../global/constants';
import FileSVGIcon from '../../assets/images/svg/filesIconSvg';
import { RawFile } from '../../mobx/interfaces/task';
import IconButton from '../button/iconButton';
import { History } from 'history';

interface Props {
  file: RawFile;
  projectId?: string;
  history?: History;
  onClickUpdate?: (e: React.SyntheticEvent) => void;
  isClose?: boolean;
  maxWidth: number;
  onClose?: () => void;
  href?: string;
}

export const RenderFilePreview = ({
  file,
  projectId,
  history,
  isClose,
  onClickUpdate,
  maxWidth,
  onClose,
  href
}: Props) => {
  //Other variable
  const extension = extensionName(file).toLowerCase();
  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClose?.();
  };
  return (
    <FileBoxMain key={file?.size} maxWidth={maxWidth}>
      <a role='button' onClick={onClickUpdate} href={href} rel='noopener noreferrer'>
        <FileBoxContainer>
          <FileBox>
            <ImageDiv className='image-div'>
              {/* File ICon design with text */}
              {(!file?.uploadFileType || file?.uploadFileType === FILE_TYPES.UPLOAD) &&
              !FILE_EXTENSIONS.includes(extension) ? (
                <FileIconDiv>
                  <FileSVGIcon name={'blank'} height='32' width='32' viewBox='0 0 60 60' />
                  <FileType fontSize={extension?.length <= 4 ? 7 : 5} className='file-text'>
                    {extension?.length <= 5 && extension?.split('.')?.pop()?.toUpperCase()}
                  </FileType>
                </FileIconDiv>
              ) : (
                <FileSVGIcon
                  name={
                    !file?.uploadFileType || file?.uploadFileType === FILE_TYPES.UPLOAD
                      ? extension
                      : `icon_${file?.uploadFileType}`
                  }
                  height='32'
                  width='32'
                  viewBox='0 0 60 60'
                />
              )}
            </ImageDiv>
            {/* File name and File size  */}
            <FileInfo>
              <FileTitle className='h4'>{file?.name}</FileTitle>
              {file?.size && parseFloat(file?.size) > 0 && <FileSize>{file?.size}</FileSize>}
            </FileInfo>
          </FileBox>
          {/* File Close/Remove Icon  */}
          {isClose && (
            <IconButton
              iconName='new-close-icon'
              size={ICON_BUTTON_SIZE.EXTRA_SMALL}
              variant={ICON_BUTTON_TYPE.TERTIARY}
              onClick={handleClose}
            />
          )}
        </FileBoxContainer>
      </a>
    </FileBoxMain>
  );
};
